<template>
  <div>
    <SubNav
      :title="title"
      :description="description"
      :link="{
        text: 'Existing Roles',
        href: '/users/roles',
        class: 'text-primary text-decoration-underline',
      }"
    />
    <div class="container-fluid p-3">
      <div class="">
        <div v-loading="loading" class="row p-5">
          <div class="col-12 mb-3">
            <h4 class="text-primary mt-2">Create New Role</h4>
            <strong>Role Details</strong>
          </div>
          <div class="col-md-6 mb-3">
            <label for="roleName">Role name*</label>
            <input id="roleName" v-model="roleName" type="text" class="form-control" />
          </div>
          <div class="col-12 mb-3">
            <p>Permissions</p>
            <div class="row">
              <div v-for="perm in perms" :key="perm.name" class="col-6 col-md-4">
                <input
                  :id="perm.name.replace(' ', '-')"
                  v-model="perm.selected"
                  type="checkbox"
                  class="mr-2"
                />
                <label :for="perm.name.replace(' ', '-')">{{ perm.name }}</label>
              </div>
            </div>
          </div>
          <div class="col-12">
            <b-button v-loading="creating" class="btn btn-primary px-5 py-2 mr-3" @click="onCreate"
              >Create Role</b-button
            >
            <button class="btn btn-outline-danger py-2 border-0" @click="$router.back()">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubNav from "../../components/SubNav.vue";
import defaultPermissions from "./permissions";
// import { mapActions } from "vuex";

import mixin from "../../mixins/dashboard-data";

// import request from "../../utils/request";

export default {
  name: "Profile",
  components: { SubNav },
  mixins: [mixin],
  data() {
    return {
      roleName: "",
      creating: false,
      loading: false,
      perms: [],
    };
  },
  computed: {
    title() {
      return "Roles and Permissions";
    },
    description() {
      return 'Manage Existing Roles and Permissions, by clicking on the "Edit Roles" Link';
    },
  },
  async mounted() {
    if (!this.permissions.length) {
      this.loading = true;
      try {
        await this.loadPermissions();
        if (this.permissions.length <= 3) {
          await this.createPerm();
          await this.loadPermissions();
        }
      } catch (error) {
        console.log(error);
        this.$notify.error("Unable to load Permissions");
      }
      this.loading = false;
    }
    this.perms = this.permissions.reverse().map((p) => ({ ...p, selected: false }));
  },
  methods: {
    // ...mapActions("users", ["createRole"]),
    async createPerm() {
      for (const perm of defaultPermissions) {
        console.log("creating...", perm);
        await this.createPermission(perm);
      }
    },
    onCreate() {
      this.creating = true;
      const role = {
        name: this.roleName,
        permissions: this.perms.filter((p) => p.selected).map((p) => p.id),
      };
      this.createRole(role)
        .then(() => {
          this.$notify.success("Role Created Successfully");
          this.$router.push("/users/roles");
        })
        .catch((err) => {
          console.log(err);
          this.$notify.error("An error occured!");
        })
        .finally(() => {
          this.creating = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.user-roles {
  max-height: 270px;
  overflow-y: auto;
  scroll-behavior: smooth;
}
</style>
